import { Routes } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { SociosanitaryGuard } from "./_guards/sociosanitary.guard";
import { environment } from "src/environments/environment";
import { PublicRedirectionGuard } from "./_guards/public-redirection.guard";
const ɵ0 = { title: "Acceso" }, ɵ1 = () => import("./_modules/login/login.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ2 = { title: "Recuperar contraseña" }, ɵ3 = () => import("./_modules/recovery/recovery.module.ngfactory").then(m => m.RecoveryPageModuleNgFactory), ɵ4 = { title: "Cambiar contraseña" }, ɵ5 = () => import("./_modules/changepassword/changepassword.module.ngfactory").then(m => m.ChangepasswordPageModuleNgFactory), ɵ6 = { title: "about", type: "0" }, ɵ7 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ8 = { title: "beneficiaries", type: "1" }, ɵ9 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ10 = { title: "faq", type: "2" }, ɵ11 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ12 = { title: "id-4", type: "3" }, ɵ13 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ14 = { title: "id-5", type: "4" }, ɵ15 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ16 = { title: "Servicios" }, ɵ17 = () => import("./_modules/service-index/service-index.module.ngfactory").then(m => m.ServiceIndexPageModuleNgFactory), ɵ18 = { title: "Servicio id" }, ɵ19 = () => import("./_modules/service-details/service-details.module.ngfactory").then(m => m.ServiceDetailsPageModuleNgFactory), ɵ20 = { title: "Solicitud de servicio id" }, ɵ21 = () => import("./_modules/service-request/service-request.module.ngfactory").then(m => m.ServiceRequestPageModuleNgFactory), ɵ22 = { title: "Contacto" }, ɵ23 = () => import("./_modules/contact/contact.module.ngfactory").then(m => m.ContactPageModuleNgFactory), ɵ24 = { title: "feature id" }, ɵ25 = () => import("./_modules/feature/feature.module.ngfactory").then(m => m.FeaturePageModuleNgFactory), ɵ26 = { title: "Formulario ficha sociosanitaria" }, ɵ27 = () => import("./_modules/sociosanitary/sociosanitary.module.ngfactory").then(m => m.SociosanitaryPageModuleNgFactory);
const routes = [
    {
        path: "",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    },
    {
        path: ":locale",
        data: ɵ0,
        loadChildren: ɵ1,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/recovery",
        data: ɵ2,
        loadChildren: ɵ3,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/change-password/:token",
        data: ɵ4,
        loadChildren: ɵ5,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/about",
        data: ɵ6,
        loadChildren: ɵ7,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/beneficiaries",
        data: ɵ8,
        loadChildren: ɵ9,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/faq",
        data: ɵ10,
        loadChildren: ɵ11,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-4",
        data: ɵ12,
        loadChildren: ɵ13,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-5",
        data: ɵ14,
        loadChildren: ɵ15,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-index",
        data: ɵ16,
        loadChildren: ɵ17,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-details/:id",
        data: ɵ18,
        loadChildren: ɵ19,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id",
        data: ɵ20,
        loadChildren: ɵ21,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/contact",
        data: ɵ22,
        loadChildren: ɵ23,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/feature/:id",
        data: ɵ24,
        loadChildren: ɵ25,
    },
    {
        path: ":locale/sociosanitary",
        data: ɵ26,
        loadChildren: ɵ27,
        canActivate: [SociosanitaryGuard, AuthGuard]
    },
    {
        path: "**",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27 };
